<template>
    <div class="editable" contenteditable :placeholder="placeholder" v-html="localValue" @input="onInput"></div>
</template>
  
  <script>
  export default {
    props: {
      value: String,
      placeholder: String
    },
    data () {
        return {
            localValue: null
        }
    },
    created () {
      this.localValue = this.value
    },
    methods: {
      onInput (e) {
        this.$emit('input', e.target.innerHTML)
      }
    }
  }
  </script>
<style lang="scss" scoped>
.editable{
    display: block;
    font-size: 0.875rem;
    width: 100%;
    padding: .7rem 2.2rem;
    font-weight: 400;
    line-height: 1.6;
    color: #8A8A8A;
    background-color: #eee;
    background-clip: padding-box;
    border: 1px solid #979797;
    border-radius: 23px;
    transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    min-height: 100px;
}
[contenteditable=true]:empty::before{
  content: attr(placeholder);
  pointer-events: none;
  display: block;
}
[contenteditable=true]:empty:focus::before{
    content: "";
}
</style>


// WEBPACK FOOTER //
// src/components/base/forms/ContentEditable.vue